import { createActionThunk } from 'redux-thunk-actions'
import { handleActions } from 'redux-actions'
import { actions as toastr } from 'react-redux-toastr'
import _ from 'lodash'

import api from 'core/api'
import { getCurrentUserThunk } from '../index'

const getType = type => `@users/current/kyc/${type}`

export const getKyc = createActionThunk(getType('FETCH'), api('/users/current/kyc'))

export const submitKycThunk = createActionThunk(
  getType('SUBMIT'),
  api('/users/current/kyc', { method: 'POST' })
)

export const submitKyc = props => dispatch =>
  dispatch(submitKycThunk(props))
    .then(() => dispatch(getCurrentUserThunk()))
    .catch(res => {
      if (_.has(res, 'error.error.details') && _.isString(res.error.error.details))
        dispatch(toastr.add({ type: 'error', message: res.error.error.details }))
      if (_.has(res, 'error.error.type') && res.error.error.type === 'validation_error')
        dispatch(toastr.add({ type: 'error', message: 'Validation error' }))
      throw res.error.error.details
    })

const initialState = {}

export default handleActions(
  {
    [getKyc.START]: state => ({ ...state, loading: true }),
    [getKyc.SUCCEEDED]: (state, { payload }) => ({ ...state, ...payload }),
    [getKyc.FAILED]: (state, { payload }) => ({ ...state, ...payload }),
    [getKyc.ENDED]: state => ({ ...state, loading: false }),
    [submitKycThunk.START]: state => ({ ...state, loading: true }),
    [submitKycThunk.SUCCEEDED]: (state, { payload }) => ({ ...state, error: {} }),
    [submitKycThunk.FAILED]: (state, { payload }) => ({ ...state, ...payload }),
    [submitKycThunk.ENDED]: state => ({ ...state, loading: false })
  },
  initialState
)



// WEBPACK FOOTER //
// ./src/modules/users/current/kyc/index.js